import { ASSERT_OK, ASSERT_STATUS_CODE } from './constants';
import { AssertStatusCode } from './rest';

export class BaseError extends Error {
    code: string;

    constructor(...params: any[]) {
        super(...params);

        // required to keep prototype chain when targeting ES5 see
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export const myloungeRedirect = () => {
    window.location.href = '/event';
};
export const orderOverviewRedirect = () => {
    window.location.href = '/myaccount/order';
};
export const reloadHandler = () => window.location.reload();

export const redirectHandler = (target: string) => {
    window.location.href = target;
};

type ErrorHandler = (error?: Error) => void;

const ERROR_HANDLER_MAP: Record<string, ErrorHandler> = {};
const defineError = (key: string, handler: ErrorHandler) => {
    ERROR_HANDLER_MAP[key] = handler;
};

defineError(ASSERT_OK, reloadHandler);
defineError(ASSERT_STATUS_CODE, (error: AssertStatusCode) => {
    switch (error.statusCode) {
        case 401:
        case 403:
            reloadHandler();
            break;
        case 404:
            orderOverviewRedirect();
            break;
        case 500:
            myloungeRedirect();
            break;

        default:
    }
});

export const createErrorHandler = (
    defaultHandler: ErrorHandler = (_: Error) => myloungeRedirect,
) => (error: Error) => {
    if (error instanceof BaseError) {
        return ERROR_HANDLER_MAP[error.code](error);
    }

    defaultHandler(error);
};
